import { AssignInvoiceCriteriaEntity, EMPTY_ASSIGN_INVOIC_CRITERIA_ENTITY } from "domain/entity/AssignInvoiceCriteria/AssignInvoiceCriteriaEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface AssignInvoiceCriteriaModelDropdownOptions {
    billToCompanyDropdownOptions: DropdownProps[],
    tariffTypeDropdownOptions: DropdownProps[],
    chargeTypeDropdownOptions: DropdownProps[],
    subChargeTypeDropdownOptions: { [key: string]: DropdownProps[] },
    containerStatusDropdownOptions: DropdownProps[],
    containerSizeDropdownOptions: DropdownProps[],
    shipmentTypeDropdownOptions: DropdownProps[],
    customerCodeDropdownOptions: DropdownProps[],
}
export interface AssignInvoiceCriteriaModelViewChangeState extends BaseViewChangeSate {
}

export interface AssignInvoiceCriteriaModel {
    isLoading: boolean,
    dynamicOptions: AssignInvoiceCriteriaModelDropdownOptions,
    criteria: AssignInvoiceCriteriaEntity,
}

export const EMPTY_ASSIGN_INVOICE_CRITERIA_MODEL: AssignInvoiceCriteriaModel = {
    isLoading: false,
    dynamicOptions: {
        billToCompanyDropdownOptions: [],
        tariffTypeDropdownOptions: [],
        chargeTypeDropdownOptions: [],
        subChargeTypeDropdownOptions: {},
        containerStatusDropdownOptions: [],
        containerSizeDropdownOptions: [],
        shipmentTypeDropdownOptions: [],
        customerCodeDropdownOptions: [],
    },
    criteria: { ...EMPTY_ASSIGN_INVOIC_CRITERIA_ENTITY }
}